import { Pipe, PipeTransform } from '@angular/core';
import { BudgetPercentDenominatorEnum } from '@enums/BudgetPercentDenominator';
import { TreeNodeData, TreeNodeType } from '@estimate/treetable/models/tree-node-data.model';
import { TreeNodeTotals } from '@models/TreeNodeTotals';
import { TreeNode } from 'primeng/api';

@Pipe({
  name: 'nodeTotalPercentage',
  pure: false
})
export class NodeTotalPercentagePipe implements PipeTransform {
  public transform<T>(
    node: TreeNode<TreeNodeData<T>>,
    [rootNode]: TreeNode<TreeNodeData<T>>[],
    property: keyof TreeNodeTotals,
    denominator: BudgetPercentDenominatorEnum
  ): string {
    const nodeValue = Number(node.data?.totals[property]) || 0;
    let denominatorValue = 0;

    if (node.data.type === TreeNodeType.Project) return '100%';

    if (denominator === BudgetPercentDenominatorEnum.Project) {
      denominatorValue = Number(rootNode?.data?.totals[property]) || 0;
    } else {
      denominatorValue = Number(node.parent?.data?.totals[property]) || 0;
    }

    if (!denominatorValue) return '0%';

    return `${Math.round((100 * nodeValue) / denominatorValue)}%`;
  }
}
